import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const apiurl = "https://api.stockastix.com";

export const signupUser = createAsyncThunk(
  "auth/signupUser",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${apiurl}/users/signup/`, data.values);
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data.error);
      }
      return rejectWithValue(
        "An error occurred during signup. Please try again."
      );
    }
  }
);

export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${apiurl}/users/login/`, data.values);
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data.error);
      }
      return rejectWithValue("Invalid email or password.");
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: null,
    accessToken: "",
    refreshToken: "",
    loading: false,
    error: null,
    isLoggedIn: false,
  },
  reducers: {
    logout: (state) => {
      state.user = null;
      state.error = null;
      state.accessToken = "";
      state.refreshToken = "";
      state.isLoggedIn = false;

      // Only remove refresh_token
      localStorage.removeItem("refresh_token");
    },
    setTokensFromStorage: (state, action) => {
      state.accessToken = action.payload.accessToken;
      state.isLoggedIn = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(signupUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(signupUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
      })
      .addCase(signupUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "An error occurred during signup.";
      })
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        const { user, access_token, refresh_token } = action.payload;

        state.loading = false;
        state.user = user;
        state.accessToken = access_token;
        state.refreshToken = refresh_token;
        state.isLoggedIn = true;

        // Persist only refresh_token in localStorage
        localStorage.setItem("refresh_token", refresh_token);
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { logout, setTokensFromStorage } = authSlice.actions;
export default authSlice.reducer;
